define(function(require) {
	const Marionette = require('backbone.marionette');
	const $ = require('jquery');
	const StandardView = require('./login_standard/v_lov_login');
	const CustomSSOView = require('./login_customsso/v_lov_login');
	const LoggedInUserView = require('./logged_in_user/v_lov_logged_in_user');
	const ViewManager = require('civicsUtils/view_manager');
	const UrlObject = require('civicsBase/url-object');

	const tpl = require('./t_lov_login.hbs');

	return Marionette.LayoutView.extend({
		template: tpl,
		regions: {
			loginViewRegion: '.login-container',
		},
		events: {
			'click @ui.links': 'closeModal'
		},
		ui: {
			links: '.link-register,.link-forgot',
			loginContainer: '.login-container',
		},
		initialize: function(options) {
			this.options = options;
			this.config = options.config;
			this.isModal = options.isModal;
			this.options.isRedirect = false;
			this.modalTitle = options.modalTitle;
			this.fullTitleOverride = options.fullTitleOverride;
			this.modalRegion = options.modalRegion;
			this.instance = "";
			this.checkLoggedInStatus();
			if (this.options.config !== 'undefined' && this.options.config.instance !== undefined) {
				this.instance = options.config.instance.split("_WAR_").pop();
			}

			if(this.isModal) {
				this.options.setTitle = false;
			}

			const urlObj = UrlObject.parse(window.location.href);
			if (urlObj.url.param._58_redirect) {
				this.redirectURL = decodeURIComponent(urlObj.url.param._58_redirect);
				this.options.isRedirect = true;
			}
			else if (urlObj.url.param.p_p_id) {
				if (urlObj.url.param['_' + urlObj.url.param.p_p_id + '_redirect']) {
					this.redirectURL = decodeURIComponent(urlObj.url.param['_' + urlObj.url.param.p_p_id + '_redirect']);
					this.options.isRedirect = true;
				}
			}
			if( urlObj.url.param.RelayState ){
				this.options.relayState = decodeURIComponent(urlObj.url.param.RelayState);
				this.options.isRedirect = true;
			}
		},
		onRender: function() {			
			if(!this.options.isUserLoggedIn){
				if (this.config.usesSSO && this.config.mySSOContent && this.config.mySSOContent != "") {
					this.loginView = new CustomSSOView(this.options);

				}else {
					this.loginView = new StandardView(this.options);
				}
			}else{
				this.loginView = new LoggedInUserView(this.options);
			}
			ViewManager.loading(false);
			this.loginViewRegion.show(this.loginView);
		},
		closeModal: function(e) {
			if(e) {
				e.preventDefault();
				e.stopPropagation();
				window.location.assign(e.target.href);
			}
		},
		onShow: function() {
			var isFocus = false;
			var $loginForm = this.$el;

			if(this.config.isMaintenanceMode)
				ViewManager.openAlert( i18n.t('CIVICS.COMMON.SERVER_ERRORS.MAINT_MODE'), true );
			
			if($loginForm.closest(".util-menu-item").length == 0) {
				$loginForm.addClass("login-on-page");
			}

			if(this.options.isRedirect) {
				$loginForm.closest(".util-menu-item").addClass("open");
				$loginForm.parents('.rhy-body').find('.portlet-login').hide();
			}
			
			if($loginForm.find(".civics-login").length > 0 && !$loginForm.hasClass("login-on-page")) {
				$loginForm.find(".civics-login").on("focusin", (e) => {
					setTimeout(() => {
						this.trapFocus($loginForm);
					}, 1);
				})
			}
		},
		trapFocus: function(el) {
			// On tab key down, check if it's the first or last item, then move the focus correctly			
  			el.on('keydown', 'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, div[tabindex="0"]', function(e) {
			var isTabPressed = (e.key === 'Tab' || e.keyCode === 9);

			if (!isTabPressed) {
				return;
			}

			var focusableEls = el.find('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, div[tabindex="0"]').not(":hidden");
			$(".firstFocusable, .lastFocusable").removeClass("firstFocusable").removeClass("lastFocusable");
			focusableEls.eq(0).addClass("firstFocusable");
			focusableEls.eq(focusableEls.length - 1).addClass("lastFocusable");

			if ( e.shiftKey ) /* shift + tab */ {
				if(!el.closest(".util-menu-item").hasClass("open")) 
					return;
				
				if ((document.activeElement.className).indexOf("firstFocusable") > -1) {
					el.find(".lastFocusable").focus();
					e.preventDefault();
				}
			} else /* tab */ {
				
				if(!el.closest(".util-menu-item").hasClass("open")) 
					return;
				if ((document.activeElement.className).indexOf("lastFocusable") > -1) {
					el.find(".firstFocusable").focus();
					e.preventDefault();
				}
			}
			});
		},
		checkLoggedInStatus: function() {
			//no need to probe services again, we store this in the precheck.
			if( App.user.id && App.user.id > 1){
				this.options.isUserLoggedIn = true;
				this.options.currentUser = App.user.contactId;
			}
			else {
				this.options.isUserLoggedIn = false;
			}
		},
		uniqueID: function(id) {
			// Because the login portlet is used in the header and sometimes in the body of the page, we need a unique ID anywhere ID is used
			if (this.instance !== undefined && this.instance.length > 0)
				return id + '-' + this.instance;
			else
				return id;
		},
		templateHelpers: function() {
			return {
				isModal: this.isModal,
				redirectURL:  this.redirectURL,
				UniqueIDRedirect: this.uniqueID("redirect"),
				//set the modal title for service requests login modal
				setModalTitle: (() => {
					if (!this.isModal) {
						return i18n.t('CIVICS.LOGIN.LOGIN_TITLE_MODAL');
					}
					
					if (this.modalTitle != undefined) {
						if (this.fullTitleOverride) {
							return this.modalTitle;
						}
						return i18n.t('CIVICS.LOGIN.LOGIN_SERVICEREQUEST_MODAL_TITLE', { 
							srType: this.modalTitle, 
							interpolation: { escapeValue: false } 
						});
					}
					
					return i18n.t('CIVICS.LOGIN.LOGIN_TITLE_MODAL');
				})()
			};
		},
	});
});
